import {DropdownItem} from "@atlaskit/dropdown-menu";
import type {ComponentProps} from "react";

export function AnankeDropdownItem({
    dataAnalyticsEvent = null,
    dataAnalyticsProps = null,
    ...props
}: ComponentProps<typeof DropdownItem> & {
    dataAnalyticsEvent?: string | null;
    dataAnalyticsProps?: string | null;
}) {
    const analyticsHtmlAttributes: {
        "data-analytics-event"?: string;
        "data-analytics-props"?: string;
    } = {};
    if (dataAnalyticsEvent !== null) {
        analyticsHtmlAttributes["data-analytics-event"] = dataAnalyticsEvent;
    }
    if (dataAnalyticsProps !== null) {
        analyticsHtmlAttributes["data-analytics-props"] = dataAnalyticsProps;
    }
    return (
        <DropdownItem
            {...props}
            // DropdownItem's public props omit data attributes. It still forwards unknown rest onto the menu button.
            {...(analyticsHtmlAttributes as ComponentProps<typeof DropdownItem>)}
        />
    );
}
